var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapChart"},[_c('div',{staticClass:"echarts"},[_c('div',{ref:"myEchart",style:({width: '580px', height: '333px'})})])])}
var staticRenderFns = []

export { render, staticRenderFns }